import type { EntityValidationRules } from "../services/validationService";
import Enum from "./enum";

export default class Region extends Enum {
  nutsCode: string;
  licensePlateLetter: string;
}

export const RegionValidationRules: EntityValidationRules<Region> = {
  name: {
    required: true,
  },
  licensePlateLetter: {
    required: true,
    isLength: {
      min: 1,
      max: 1,
    },
    isAlphanumericText: true,
  },
  nutsCode: {
    required: true,
    isNutsCode: true,
  },
};
